export default IconSwipeUp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-swipe-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
  <path d="M12 12v-8" />
  <path d="M9 7l3 -3l3 3" />
</svg>`;